module.exports = "<p>\r\n  base-datatable works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/base/base-datatable/base-datatable.component.html
// module id = ./src/app/pages/base/base-datatable/base-datatable.component.html
// module chunks = main